import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { IdNameModel } from "services/KnowfullyAdminClient";

type SelectUserCredentialTypeProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

export default function SelectUserCredentialType(
  props: SelectUserCredentialTypeProps
) {
  const { formatMessage: t } = useIntl();
  const { userCredentialService } = useGlobalContext();

  const fetchedData = useQuery(
    ["userCredentialService.getUserCredentialTypes"],
    () => userCredentialService.getUserCredentialTypes()
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "fetchError" })}
    />
  );
}
